import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/user-settings')({
    staticData: {
        // Portal-only fleet users have no settings surface (CUR-1049): the profile
        // and notification pages are console concepts, and the account menu hides
        // their entries for the same users.
        consoleWorkspace: true,
        breadcrumb: {
            title: 'User settings',
            inactive: true,
        },
    },
    component: Outlet,
});
